import Icon from '@atoms/Icon/Icon';
import { ILink } from '@models/ILink';
import classNames from 'classnames';

interface Props {
  readonly className?: string;
  readonly editHint?: string;
  readonly link: ILink;
  readonly dataTestId?: string;
}

const ReturnLink = ({
  className,
  editHint,
  link,
  dataTestId = 'Return-Link',
}: Props) => (
  <a
    href={link.url}
    className={classNames(
      className,
      'body-two group flex flex-row items-center gap-x-1 text-black-100 hover:text-grey-500 dark:text-white dark:hover:text-yellow'
    )}
    data-epi-property-name={editHint}
    data-testid={dataTestId}
  >
    <Icon
      name="chevron_right"
      className="-translate-x-2 rotate-180"
      colorClassName="text-black-100 group-hover:text-grey-500 dark:text-white dark:group-hover:text-yellow"
    />
    {link.name}
  </a>
);

export default ReturnLink;
